import { IncidentReportForm } from '../components/IncidentReportForm';
import { PageContainer } from '../components/PageContainer';

export const TeacherIncidentReport = () => {
	return (
		<PageContainer>
			<IncidentReportForm />
		</PageContainer>
	);
};
